import { render, staticRenderFns } from "./GtexMeta.vue?vue&type=template&id=41e49379&scoped=true&"
import script from "./GtexMeta.vue?vue&type=script&lang=js&"
export * from "./GtexMeta.vue?vue&type=script&lang=js&"
import style0 from "./GtexMeta.vue?vue&type=style&index=0&id=41e49379&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e49379",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCardTitle,VCol,VContainer,VDataTable,VRow})
